module.exports = __webpack_public_path__ + "img/743.37116858.jpg";